import { Trophy, Building2, Compass, Handshake, MapPin, Home } from "lucide-react";
import { FEATURES } from "@/data/content";
import { SectionLabel } from "@/components/SectionLabel";
import { AccentHeading } from "@/components/AccentHeading";
import { Reveal } from "@/components/Reveal";
import { TiltCard } from "@/components/TiltCard";

const ICONS = { Trophy, Building2, Compass, Handshake, MapPin, Home };

export const WhyChooseUs = () => (
  <section id="services" data-testid="why-choose-us" className="bg-[var(--bg-primary)] py-16 md:py-24 lg:py-28">
    <div className="container-pad">
      <div className="max-w-2xl">
        <Reveal><SectionLabel>WHY CHOOSE US</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <AccentHeading as="h2" text="What Sets Us *Apart*" className="mt-4 block text-4xl leading-[1.04] md:text-5xl lg:text-6xl" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 max-w-[52ch] text-[var(--text-secondary)]">Two and a half decades of craftsmanship, trust, and an unwavering commitment to quality.</p>
        </Reveal>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
        {FEATURES.map((f, i) => {
          const Icon = ICONS[f.icon] || Home;
          return (
            <Reveal key={f.title} delay={(i % 3) * 0.06}>
              <TiltCard testId={`why-card-${i + 1}`} className="h-full">
                <div className="glass-card h-full rounded-[24px] p-7">
                  <div className="grid h-12 w-12 place-items-center rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-accent-surface)] text-[var(--accent-secondary)]">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 font-playfair text-xl text-[var(--text-primary)]">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[var(--text-secondary)]">{f.desc}</p>
                </div>
              </TiltCard>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
